export default __webpack_public_path__ + "static/media/illustration-elements_icon-discord.ab532002.svg";